import { MetaObject } from '@softline/dynamic';
import { TimeReport } from '../time-report.model';

export const timeReportMeta: MetaObject<TimeReport> = {
  id: {
    type: 'string',
    hidden: true,
  },
  date: {
    type: 'date',
    format: 'DATE.DEFAULT',
    hidden: true,
  },
  description: {
    type: 'string',
    hidden: true,
  },
  from: {
    type: 'time',
    format: 'TIME.DEFAULT',
    hidden: true,
  },
  to: {
    type: 'time',
    format: 'TIME.DEFAULT',
    hidden: true,
  },
  kst: {
    type: 'fieldOk',
    format: '{{kostenstelle}} - {{kontotext1}}',
    of: {
      id: { type: 'number' },
      kostenstelle: { type: 'number' },
      kontotext1: { type: 'string' },
    },
  },
  customer: {
    type: 'object',
    format: '{{number}} - {{name}}',
    object: {
      id: { type: 'number' },
      number: { type: 'number' },
      name: { type: 'string' },
    },
  },
  object: {
    type: 'object',
    format: '{{number}} - {{name}}',
    object: {
      id: { type: 'number' },
      number: { type: 'number' },
      name: { type: 'string' },
    },
  },
  zeit: {
    type: 'duration',
    format: 'DURATION.DEFAULT',
  },
  kzverrzeit: {
    type: 'select',
    options: [
      { value: 'A', label: 'Auftrag', icon: 'check' },
      { value: 'L', label: 'Lieferschein', icon: 'close' },
      { value: 'R', label: 'Regie', icon: 'close' },
      { value: 'K', label: 'Keine', icon: 'close' },
    ],
  },
  zbewe: {
    type: 'object',
    format: '',
    hidden: true,
    object: {},
  },
  zbewegungsarten: {
    type: 'array',
    of: {},
  },
  bewegungsart: {
    type: 'string',
  },
};
